export function filteredPeople() {
    return this.people;
}

export function filteredPeopleWithEmptyOption() {
    return this.people
        .filter(person => person.id == null || !!person.email);
}

export function filteredNetworksWithEmptyOption() {
    console.log(this)
    return this.networks
        .filter(network => network.id == null || network.id !== this.id);
}
